import React, { useEffect, useState } from "react";
import {
  Eye,
  EyeSlash,
  Shop,
  Phone,
  ArrowRight,
  ShieldCheck,
  LightningCharge,
  PersonBadge,
} from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Utils from "../../utils";
import { createSendOtp } from "../../services/authServices";
import { decryptData } from "../../utils/crypto";
import { authActions } from "../../store";
import CONFIG from "../../config";
import { notify } from "../../components/Common/Alerts";
import { useConfig } from "../../components/Context/ConfigContext";

const Login = () => {
  const deviceToken = localStorage.getItem("app_fcm_token");
  const deviceType = localStorage.getItem("device_type");
  const { configData, loading } = useConfig();

  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    mobile: "",
  });
  let errorsObj = { mobile: "" };

  const [errors, setErrors] = useState(errorsObj);
  const [isLoading, setIsLoading] = useState(false);
  const [roleId, setRoleId] = useState("");

  useEffect(() => {
    const role = configData?.role_store_owner || location?.state?.role_id;

    if (role) {
      setRoleId(role);
    }
  }, [configData?.role_store_owner, location?.state?.role_id]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      const cleanedValue = value.replace(/\D/g, "").slice(0, 10);

      setFormData((prev) => ({
        ...prev,
        mobile: cleanedValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   let errorObj = { ...errorsObj };
  //   let error = false;

  //   if (!formData?.mobile) {
  //     errorObj.mobile = "Mobile is required";
  //     error = true;
  //   } else {
  //     const mobileRegex = /^\d{10}$/;
  //     if (!mobileRegex.test(formData.mobile)) {
  //       errorObj.mobile = "Enter a valid 10-digit mobile number";
  //       error = true;
  //     }
  //   }

  //   setErrors(errorObj);
  //   if (error) return;

  //   let obj = {
  //     mobile: formData?.mobile?.trim() || "",
  //     password: formData?.password?.trim() || "",
  //     role_id: roleId,
  //     device_token: deviceToken,
  //     device_type: deviceType,
  //   };
  //   setIsLoading(true);

  //   navigate("/dashboard", item:obj);

  //   // createlogin(obj)
  //   //   .then((response) => {
  //   //     const decrypted = decryptData(response.data.data);
  //   //     let userData = decrypted?.user;

  //   //     if (userData) {
  //   //       Utils.setDetail(decrypted);
  //   //       Utils.setIntervalRemove();
  //   //       dispatch(authActions.login(decrypted));
  //   //       if (
  //   //         decrypted.is_store_selected === 0 &&
  //   //         Number(userData.role_id) === CONFIG.ROLE_OWNER
  //   //       ) {
  //   //         navigate("/store-add");
  //   //       } else {
  //   //         navigate("/dashboard");
  //   //       }
  //   //     }
  //   //   })
  //   //   .catch((error) => {
  //   //     // notify.error(Utils.getErrorMessage(error));
  //   //     notify.error(Utils.getErrorMessage(error));
  //   //   })
  //   //   .finally(() => {
  //   //     setIsLoading(false);
  //   //   });
  // };

  const handleMobileValidation = () => {
    let errorMsg = "";

    const mobileRegex = /^\d{10}$/;

    if (!formData.mobile) {
      errorMsg = "Mobile is required";
    } else if (!mobileRegex.test(formData.mobile)) {
      errorMsg = "Enter a valid 10-digit mobile number";
    }

    setErrors((prev) => ({
      ...prev,
      mobile: errorMsg,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let errorObj = { ...errorsObj };
    let error = false;

    if (!formData?.mobile) {
      errorObj.mobile = "Mobile is required";
      error = true;
    } else {
      const mobileRegex = /^\d{10}$/;
      if (!mobileRegex.test(formData.mobile)) {
        errorObj.mobile = "Enter a valid 10-digit mobile number";
        error = true;
      }
    }

    setErrors(errorObj);
    if (error) return;

    let obj = {
      mobile: formData?.mobile || "",
      role_id: roleId,
      // device_token: deviceToken,
      // device_type: deviceType,
    };

    let data = {
      mobile: formData?.mobile || "",
      role_id: roleId,
      device_token: deviceToken,
      device_type: deviceType,
    };
    setIsLoading(true);

    createSendOtp(obj)
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        notify.success(decrypted.message);
        navigate("/otp", {
          state: { data },
          replace: true,
        });
        setIsLoading(true);

        // let userData = decrypted?.user;

        // if (userData) {
        //   Utils.setDetail(decrypted);
        //   Utils.setIntervalRemove();
        //   dispatch(authActions.login(decrypted));
        //   if (
        //     decrypted.is_store_selected === 0 &&
        //     Number(userData.role_id) === CONFIG.ROLE_OWNER
        //   ) {
        //     navigate("/store-add");
        //   } else {
        //     navigate("/dashboard");
        //   }
        // }
      })
      .catch((error) => {
        let decryptError = decryptData(error.response.data.data);
        notify.error(decryptError?.message);
        // notify.error(Utils.getErrorMessage(error));
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const isValidMobile = /^\d{10}$/.test(formData.mobile);

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-brand-body font-sans overflow-hidden">
      <div className="w-full md:w-1/2 flex items-center justify-center p-8 md:p-16 relative">
        <div className="absolute top-0 left-0 w-64 h-64 bg-brand-orange/5 rounded-full blur-3xl -z-10 animate-blob" />

        <div className="w-full max-w-md animate-fade-up">
          <div
            className="flex items-center gap-2 mb-8 cursor-pointer"
            onClick={() => navigate("/")}
          >
            <div
              className={`${roleId === configData?.role_store_owner ? "bg-brand-orange" : "bg-indigo-600"} p-2 rounded-xl text-white shadow-lg transition-colors duration-500`}
            >
              <Shop size={24} />
            </div>
            <span className="text-2xl font-extrabold text-brand-dark">
              Dukaan
              <span
                className={
                  roleId === configData?.role_store_owner
                    ? "text-brand-orange"
                    : "text-indigo-600"
                }
              >
                Setu
              </span>
            </span>
          </div>
          <div className="mb-8 animate-fade-in">
            <h2 className="text-4xl font-extrabold text-brand-dark tracking-tight leading-tight transition-all duration-500">
              {roleId === configData?.role_store_owner
                ? "Apna Business Digital Karein"
                : "Ghar Baithe Shopping"}
            </h2>
            <p
              className={`mt-3 font-medium text-sm leading-relaxed max-w-[320px] transition-colors duration-500 ${roleId === 2 ? "text-orange-600/70" : "text-indigo-600/70"}`}
            >
              {roleId === configData?.role_store_owner
                ? "Apni daily sales manage karo, stock track karo aur customer khata digital banao."
                : "Roz ki zaroorat ka samaan ab aasani se order karo."}
            </p>
          </div>
          {/*
          <div className="mb-10">
            <h2 className="text-4xl font-extrabold text-brand-dark tracking-tight">
              Welcome Back!
            </h2>
            <p className="text-gray-500 mt-2">
              Sign in to DukaanSetu to start managing orders.{" "}
            </p>
          </div> */}

          {/* ROLE SELECTOR - Segmented UI */}
          <div className="bg-slate-100 p-1.5 rounded-2xl flex items-center mb-8 relative shadow-inner">
            <button
              type="button"
              onClick={() => {
                setRoleId(configData?.role_store_owner);
                setFormData({ mobile: "", password: "" });
                setErrors({ mobile: "" });
              }}
              className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-xl font-bold text-sm transition-all duration-300 z-10 ${
                roleId === configData?.role_store_owner
                  ? "text-white"
                  : "text-slate-500 hover:text-slate-700"
              }`}
            >
              <Shop size={16} /> Store Owner
            </button>
            <button
              type="button"
              onClick={() => {
                setRoleId(configData?.role_customer);
                setFormData({ mobile: "", password: "" });
                setErrors({ mobile: "" });
              }}
              className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-xl font-bold text-sm transition-all duration-300 z-10 ${
                roleId === configData?.role_customer
                  ? "text-white"
                  : "text-slate-500 hover:text-slate-700"
              }`}
            >
              <PersonBadge size={16} /> Customer
            </button>

            {/* Sliding Background Highlighter */}
            <div
              className={`absolute top-1.5 bottom-1.5 w-[calc(50%-6px)] rounded-xl transition-all duration-500 ease-out shadow-lg ${
                roleId === configData?.role_store_owner
                  ? "left-1.5 bg-brand-orange"
                  : "left-[calc(50%+3px)] bg-indigo-600"
              }`}
            />
          </div>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="animate-fade-up [animation-delay:200ms] opacity-0 [animation-fill-mode:forwards]">
              <label className="block text-sm font-bold text-gray-800 dark:text-white mb-2">
                Mobile Number
              </label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-brand-orange transition-transform group-focus-within:scale-110">
                  <Phone size={18} />
                </div>
                <input
                  type="text"
                  inputMode="numeric"
                  placeholder="Enter 10 digit number"
                  className="w-full pl-12 pr-4 py-4 bg-white border border-gray-100 rounded-2xl outline-none focus:border-brand-orange focus:ring-4 focus:ring-brand-orange/10 transition-all font-medium shadow-sm text-black placeholder-gray-400"
                  value={formData.mobile}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onBlur={handleMobileValidation}
                  name="mobile"
                  min={0}
                />
              </div>
              {errors.mobile && (
                <p className="text-red-500 text-xs mt-1">{errors.mobile}</p>
              )}
            </div>

            <div className="pt-2 animate-fade-up [animation-delay:600ms] opacity-0 [animation-fill-mode:forwards]">
              <button
                type="submit"
                className={`w-full py-4 rounded-2xl font-bold text-lg shadow-xl transition-all flex items-center justify-center gap-3 active:scale-95 ${
                  roleId === 3
                    ? "bg-indigo-600 hover:bg-indigo-700 text-white shadow-indigo-500/30"
                    : "bg-brand-gradient text-white shadow-brand-orange/20"
                } ${
                  !isValidMobile || isLoading
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                disabled={!isValidMobile || isLoading}
              >
                {isLoading ? (
                  <>
                    <svg
                      className="animate-spin h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      />
                    </svg>
                    Logging in...
                  </>
                ) : (
                  <>
                    Login to Account <ArrowRight strokeWidth={3} />
                  </>
                )}
              </button>
            </div>
          </form>

          {/* {roleId === CONFIG.ROLE_CUSTOMER && (
            <p className="mt-8 text-center text-sm text-gray-500 font-medium animate-fade-up [animation-delay:800ms] opacity-0 [animation-fill-mode:forwards]">
              Don't have an account?
              <button
                className="ml-1 text-indigo-600 font-extrabold hover:underline"
                onClick={() => {
                  navigate("/customer-register");
                }}
              >
                Register Now
              </button>
            </p>
          )} */}

          {roleId === CONFIG.ROLE_OWNER && (
            <p className="mt-6 text-center text-sm text-gray-500">
              Ready to take your store online and grow faster?
              <button
                onClick={() =>
                  navigate("/contact-us", {
                    state: { type: "Store Support" },
                  })
                }
                className="ml-1 text-orange-600 font-semibold hover:underline cursor-pointer"
              >
                Let’s partner
              </button>
            </p>
          )}
        </div>
      </div>

      <div className="hidden md:flex w-1/2 bg-brand-gradient relative items-center justify-center p-12 overflow-hidden">
        <div className="absolute top-[-10%] right-[-10%] w-96 h-96 bg-white/10 rounded-full blur-3xl animate-blob" />
        <div className="absolute bottom-[-10%] left-[-10%] w-96 h-96 bg-orange-300/20 rounded-full blur-3xl animate-blob [animation-delay:3s]" />

        <div className="relative z-10 text-center space-y-8 animate-float">
          <div className="bg-white/10 backdrop-blur-md p-8 rounded-full border border-white/20 shadow-2xl inline-block mb-8">
            <Shop size={120} className="text-white drop-shadow-lg" />
          </div>

          <div className="text-white space-y-4">
            <h3 className="text-4xl md:text-5xl font-extrabold flex flex-wrap justify-center gap-x-3">
              Build your Digital Empire
            </h3>
            <p className="text-orange-50 text-lg max-w-sm mx-auto">
              Join 10,000+ shopkeepers who have digitized their business with
              DukaanSetu.
            </p>
          </div>

          <div className="flex justify-center gap-4 mt-12">
            <div className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-xl text-white text-sm font-bold flex items-center gap-2">
              <ShieldCheck /> 100% Secure
            </div>
            <div className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-xl text-white text-sm font-bold flex items-center gap-2">
              <LightningCharge /> Fast & Free
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
